var _defs, _rect, _rect2, _g, _text, _text2, _text3, _text4, _text5, _g2, _text6, _g3, _g4, _line, _g5, _g6, _g7, _text7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardingAgenticRunbooks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 630",
    width: 1200,
    height: 630,
    role: "img",
    "aria-label": "Onboarding at speed: tribal knowledge locked in people's heads on one side, an executable BossDrop agentic runbook on the other",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "obg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#171523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121020"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "oglow",
    cx: 0.72,
    cy: 0.45,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9db4ff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9db4ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oai",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ogold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f6cf6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2b24a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "osoft",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  })), /*#__PURE__*/React.createElement("style", null, "\n      .h  { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 800; fill: #efe9fa; }\n      .s  { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 600; fill: #b8b2cc; }\n      .eyebrow { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #cfc3ee; letter-spacing: 4px; }\n      .lab { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #121020; }\n      .node { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #e2d9f5; }\n      .warn { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #f6a35a; }\n      .step { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 600; fill: #e2d9f5; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 630,
    fill: "url(#obg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 630,
    fill: "url(#oglow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2a2547",
    strokeWidth: 1,
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 90 H1200 M0 180 H1200 M0 270 H1200 M0 360 H1200 M0 450 H1200 M0 540 H1200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 0 V630 M300 0 V630 M450 0 V630 M600 0 V630 M750 0 V630 M900 0 V630 M1050 0 V630"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 122,
    className: "eyebrow",
    fontSize: 20
  }, "ONBOARDING AT SPEED")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 192,
    className: "h",
    fontSize: 62
  }, "Day one.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 260,
    className: "h",
    fontSize: 62
  }, "Not month six.")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 310,
    className: "s",
    fontSize: 24
  }, "Tribal knowledge, made executable.")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 588,
    className: "s",
    fontSize: 20,
    opacity: 0.8
  }, "BOSSDROP.AI")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 430,
    r: 42,
    fill: "url(#ogold)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 416,
    r: 14,
    fill: "#121020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 451 a22 18 0 0 1 44 0 z",
    fill: "#121020"
  }), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 502,
    textAnchor: "middle",
    className: "node",
    fontSize: 18
  }, "New hire"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 356,
    className: "warn",
    fontSize: 17
  }, "TRIBAL KNOWLEDGE")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#f6a35a",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.5,
    strokeDasharray: "5 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192 424 C 250 424, 270 400, 320 400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 436 C 250 440, 270 470, 320 470"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 430 C 250 430, 270 540, 320 540"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#1d1a2e",
    stroke: "#5a4a32",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 400,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 470,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 540,
    r: 25
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f6a35a",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 394,
    width: 14,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 394 v-4 a4 4 0 0 1 8 0 v4",
    fill: "none",
    stroke: "#f6a35a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 464,
    width: 14,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 464 v-4 a4 4 0 0 1 8 0 v4",
    fill: "none",
    stroke: "#f6a35a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 534,
    width: 14,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 534 v-4 a4 4 0 0 1 8 0 v4",
    fill: "none",
    stroke: "#f6a35a",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    x: 386,
    y: 406,
    className: "s",
    fontSize: 16
  }, "\"Ask Priya, she set it up\""), /*#__PURE__*/React.createElement("text", {
    x: 386,
    y: 476,
    className: "s",
    fontSize: 16
  }, "\"There's a doc, it's stale\""), /*#__PURE__*/React.createElement("text", {
    x: 386,
    y: 546,
    className: "s",
    fontSize: 16
  }, "\"We just kind of know\""))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 120,
    x2: 700,
    y2: 560,
    stroke: "#2a2547",
    strokeWidth: 1.5,
    strokeDasharray: "6 8"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 150,
    width: 330,
    height: 56,
    rx: 28,
    fill: "url(#oai)",
    filter: "url(#osoft)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 150,
    width: 330,
    height: 56,
    rx: 28,
    fill: "url(#oai)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 905,
    y: 185,
    textAnchor: "middle",
    className: "lab",
    fontSize: 20
  }, "BossDrop agentic runbook"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#oai)",
    strokeWidth: 3,
    opacity: 0.85,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M905 206 V 246"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 246,
    width: 330,
    height: 280,
    rx: 16,
    fill: "#1d1a2e",
    stroke: "#3a3463",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 292,
    r: 15,
    fill: "url(#oai)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 774,
    y: 298,
    textAnchor: "middle",
    className: "lab",
    fontSize: 14
  }, "1"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 298,
    className: "step",
    fontSize: 16
  }, "Access provisioned")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 352,
    r: 15,
    fill: "url(#oai)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 774,
    y: 358,
    textAnchor: "middle",
    className: "lab",
    fontSize: 14
  }, "2"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 358,
    className: "step",
    fontSize: 16
  }, "Owners and context")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 412,
    r: 15,
    fill: "url(#oai)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 774,
    y: 418,
    textAnchor: "middle",
    className: "lab",
    fontSize: 14
  }, "3"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 418,
    className: "step",
    fontSize: 16
  }, "First task, assigned")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 472,
    r: 15,
    fill: "#1d1a2e",
    stroke: "#665a9c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 774,
    y: 478,
    textAnchor: "middle",
    className: "node",
    fontSize: 14
  }, "4"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 478,
    className: "step",
    fontSize: 16,
    opacity: 0.75
  }, "Human check-in")), /*#__PURE__*/React.createElement("g", {
    stroke: "#3a3463",
    strokeWidth: 1.5,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M774 307 V 337 M774 367 V 397 M774 427 V 457"
  })))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 905,
    y: 562,
    textAnchor: "middle",
    className: "s",
    fontSize: 17
  }, "Same knowledge. Now it runs itself.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingAgenticRunbooks);
export default __webpack_public_path__ + "static/media/onboarding-agentic-runbooks.14ac1d49fbad071ea61d05645dd74c9b.svg";
export { ForwardRef as ReactComponent };